import { Injectable } from '@angular/core'
import { catchError, Observable, throwError } from 'rxjs'
import { LogService, ScreenResolution } from 'htv-lib'
import { HttpClient, HttpParams } from '@angular/common/http'
import { environment } from '../environments/environment'
import { StatusResponseDto } from '../interfaces/dto/status-response-dto'

@Injectable({
  providedIn: 'root',
})
export class HumecloudService {
  readonly HTV_API_URL = environment.htvApiUrl

  constructor(
    private httpClient: HttpClient,
    private logService: LogService
  ) {
    // do nothing
  }

  getProjectStatus(
    projectId: string,
    resolution: ScreenResolution = ScreenResolution.RES_1080P,
    generatedProjectId?: string
  ): Observable<StatusResponseDto> {
    const url = `${this.HTV_API_URL}/public/projects/${projectId}/status`

    let params = new HttpParams().set('resolution', resolution)
    if (generatedProjectId) {
      params = params.set('generatedProjectId', generatedProjectId)
    }

    return this.httpClient.get<StatusResponseDto>(url, { params }).pipe(
      catchError(err => {
        this.logService.error(`Could not retrieve project from htv-ms`)
        this.logService.debug(err.message)
        return throwError(() => err)
      })
    )
  }
}
